import Vue from 'vue'
import Vuex from 'vuex'
import vuexPersistedState from "vuex-persistedstate";
import {init, listLanguages} from "../graphql/init";
import categories from "./categories";
import post from "./post";

Vue.use(Vuex)

const Store = new Vuex.Store({
  modules: {
    categories,
    post
  },

  actions: {
    init({commit}) {
      return init()
        .then(({languages}) => {
          let defaultLanguage = languages.find(lang => lang.isDefault)
          commit('setLanguages', languages, {root: true});
          commit('setDefaultLanguage', defaultLanguage.key, {root: true});
        })
    },
    listLanguages({commit}){
      return listLanguages()
        .then(languages => {
          commit('setLanguages', languages, {root: true});
      })
    }
  },
  mutations: {
    setLanguages(state, languages) {
      state.languages = languages;
    },
    setDefaultLanguage(state, defaultLanguage) {
      state.defaultLanguage = defaultLanguage;
    },
    setCurrentLanguage(state, currentLanguage) {
      state.currentLanguage = currentLanguage;
    },
  },
  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEBUGGING,
  plugins: [vuexPersistedState({
    key: 'sbc-cms',
  })],
  state: {
    languages: [],
    defaultLanguage: 'DE',
    currentLanguage: 'DE'
  }
})

export default Store

export {Store}
